// Personal Information Component
export default {
  // Page Title
  userCenter: "User Center",

  // Buttons
  edit: "Edit",
  save: "Save",
  unbind: "Unbind",
  scanToBinding: "Scan to Bind",

  // Form Labels
  username: "Username",
  phoneNumber: "Phone Number",
  createTime: "Create Time",
  account: "Account",
  email: "Email",
  modifiedTime: "Modified Time",
  wechat: "WeChat",

  // Status Text
  notBound: "Not Bound",
  bound: "Bound",
  noPhone: "No Phone",

  // Form Validation
  usernameLengthRule: "Length should be 2 to 20 characters",
  phoneLengthRule: "Length should be 7 to 11 characters",
  emailRequired: "Please enter email address",
  emailFormat: "Please enter a valid email address",

  // Messages
  unbindConfirm: "Are you sure you want to unbind the WeChat account?",
  tip: "Tip",
  yes: "Yes",
  no: "No",
  unbindSuccess: "Unbind successfully!",
  unbindCancelled: "Unbind cancelled",
  editSuccess: "Edit successfully",
  saveNotEmpty: "Save cannot be empty",
  phoneBinding: {
    bindPhone: "Bind phone number",
    changePhone: "Change phone number",
    notBoundTip: "Your account has not bound a phone number yet,",
    goToBind: "Go to bind",
    bindTitle: "Bind Phone Number",
    changeTitle: "Change Phone Number",
    oldPhoneLabel: "Old Phone Number",
    newPhoneLabel: "New Phone Number",
    smsCodeLabel: "SMS Verification Code",
    cancel: "Cancel",
    confirm: "Confirm",
    nextStep: "Next",
    bindSuccess: "Phone number bound successfully",
    changeSuccess: "Phone number changed successfully",
  },
};
